import './FlashMessage.css';

type FlashMessageProps = {
  message: string
};

function FlashMessage(props: FlashMessageProps) {  
  return (
    <p className="Flash-Message">{props.message}</p>
  );
}

export default FlashMessage;
